"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var use_sidecar_1 = require("use-sidecar");
require("react-focus-lock/sidecar");
require("react-remove-scroll/sidecar");
var Effect_1 = require("./Effect");
var medium_1 = require("./medium");
exports.default = use_sidecar_1.exportSidecar(medium_1.effectCar, Effect_1.Effect);



//////////////////
// WEBPACK FOOTER
// ./~/react-focus-on/dist/es5/sidecar.js
// module id = 671
// module chunks = 0